import * as env from "../utils/environment";
import { CONTENT_TYPE_JSON, CONTENT_TYPE_FORM } from "../utils/constants";
import * as models from "../models";
import * as modelsPost from "../models/post";

/**
 * Führt eine GET-Anfrage an den Server aus und gibt das Ergebnis zurück.
 * @param options
 */
export function get<T>(options: models.IApiOptions): JQueryPromise<T>
{
    return <any>$.ajax({
        type: "GET",
        contentType: (options.contentType == null) ? CONTENT_TYPE_FORM : options.contentType,
        url: env.getHost(options.endpoint),
        data: options.data,
        dataType: options.dataType,
        processData: options.processData,
        cache: options.cache,
        error: (jqXHR, textStatus, errorThrown) =>
        {
            if (jqXHR.status === 401)
                location.reload();
        }
    });
}

export function getServer<T>(options: models.IApiOptions): JQueryPromise<T>
{
    return <any>$.ajax({
        type: "GET",
        contentType: (options.contentType == null) ? CONTENT_TYPE_FORM : options.contentType,
        url: "https://calendar.in-com.de" + options.endpoint,
        data: options.data,
        dataType: options.dataType,
        processData: options.processData,
        cache: options.cache,
        error: (jqXHR, textStatus, errorThrown) =>
        {
            if (jqXHR.status === 401)
                location.reload();
        }
    });
}

//export function get2(options: models.IApiOptions)
//{
//    return $.ajax({
//        type: "GET",
//        contentType: (options.contentType == null) ? CONTENT_TYPE_FORM : options.contentType,
//        url: env.getHost(options.endpoint),
//        data: options.data,
//        dataType: options.dataType,
//        processData: options.processData,
//        cache: options.cache,
//        error: (jqXHR, textStatus, errorThrown) =>
//        {
//            if (jqXHR.status === 401)
//                location.reload();
//        }
//    });
//}

/**
 * Lädt eine Komponente vom Server.
 * @param options
 */
export function getComponent(options: models.IApiComponentOptions): void
{
    var promise = $.ajax({
        type: (options.type == null) ? "POST" : options.type,
        contentType: (options.contentType == null) ? CONTENT_TYPE_FORM : options.contentType,
        url: env.getHost(options.endpoint),
        data: options.data,
        cache: false
    });

    promise.then((component) =>
    {
        var $component: JQuery = $('<div/>').html(component).children();

        // Falls die Komponente zu keinem DOM-Element hinzugefügt werden soll,
        // werden die callbacks "beforeAppend" and "afterAppend" nicht ausgeführt.
        if (options.appendTo)
        {
            if (options.beforeAppend)
                options.beforeAppend($component);

            $(options.appendTo).append($component);

            if (options.afterAppend)
                options.afterAppend($component);
        }

        // Alles hat geklappt.
        if (options.onSuccess)
            options.onSuccess($component);
    });

    promise.fail((data) =>
    {
        if (options.onError)
            options.onError(data);
    });
}

/**
 * Führt eine POST-Anfrage an den Server aus und gibt das Ergebnis zurück.
 * @param options
 */
export function post(options: models.IApiOptions): JQueryXHR
{
    return $.ajax({
        type: "POST",
        contentType: (options.contentType == null) ? CONTENT_TYPE_FORM : options.contentType,
        url: env.getHost(options.endpoint),
        data: options.data,
        dataType: options.dataType,
        processData: options.processData,
        cache: options.cache,
        error: (jqXHR, textStatus, errorThrown) =>
        {
            if (jqXHR.status === 401)
                location.reload();
        }
    });
}

/**
 * Führt eine PUT-Anfrage an den Server aus und gibt das Ergebnis zurück.
 * @param options
 */
export function put(options: models.IApiOptions): JQueryPromise<any>
{
    return $.ajax({
        type: "PUT",
        contentType: (options.contentType == null) ? CONTENT_TYPE_FORM : options.contentType,
        url: env.getHost(options.endpoint),
        data: options.data,
        dataType: options.dataType,
        processData: options.processData,
        cache: options.cache,
        error: (jqXHR, textStatus, errorThrown) =>
        {
            if (jqXHR.status === 401)
                location.reload();
        }
    });
}

/**
 * Führt eine PATCH-Anfrage an den Server aus und gibt das Ergebnis zurück.
 * @param options
 */
export function patch(options: models.IApiOptions): JQueryPromise<any>
{
    return $.ajax({
        type: "PATCH",
        contentType: (options.contentType == null) ? CONTENT_TYPE_FORM : options.contentType,
        url: env.getHost(options.endpoint),
        data: options.data,
        dataType: options.dataType,
        processData: options.processData,
        cache: options.cache,
        error: (jqXHR, textStatus, errorThrown) =>
        {
            if (jqXHR.status === 401)
                location.reload();
        }
    });
}

/**
 * Führt eine DELETE-Anfrage an den Server aus und gibt das Ergebnis zurück.
 * @param options
 */
export function remove(options: models.IApiOptions): JQueryPromise<any>
{
    return $.ajax({
        type: "DELETE",
        contentType: (options.contentType == null) ? CONTENT_TYPE_FORM : options.contentType,
        url: env.getHost(options.endpoint),
        data: options.data,
        dataType: options.dataType,
        processData: options.processData,
        cache: options.cache,
        error: (jqXHR, textStatus, errorThrown) =>
        {
            if (jqXHR.status === 401)
                location.reload();
        }
    });
}